import React from 'react'
import IconCard from './IconCard'
import BuildIcon from '../../../public/images/icons/build.svg'
import ElectricalIcon from '../../../public/images/icons/electrical.svg'
import EssentialsIcon from '../../../public/images/icons/essential.svg'
import LearnIcon from '../../../public/images/icons/learn.svg'
import MechanicalIcon from '../../../public/images/icons/mechanical.svg'
import ShareIcon from '../../../public/images/icons/share.svg'
import SoftwareIcon from '../../../public/images/icons/software.svg'

const _icons = {
  build: BuildIcon,
  learn: LearnIcon,
  share: ShareIcon,
  electrical: ElectricalIcon,
  essential: EssentialsIcon,
  mechanical: MechanicalIcon,
  software: SoftwareIcon
};

const IconRow = ({ config, extraClassNames }) => {
  const IconCards = Object.keys(config).map((key, index) => {
  const {description, title} = config[key];
    return (
      <IconCard
        key={index}
        description={description}
        image={_icons[key]}
        title={title}
      />
    );
  })

  return (
    <div className={`icon-row grid grid--gutters grid--full large-Grid--fit ${extraClassNames}`}>
      {IconCards}
    </div>
  );
}

export default IconRow



// WEBPACK FOOTER //
// ./src/components/Home/IconRow.js